import { render } from "./SelectProductorForm.vue?vue&type=template&id=efc7e6d8&ts=true"
import script from "./SelectProductorForm.vue?vue&type=script&lang=ts"
export * from "./SelectProductorForm.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__